import React from "react";
import {Button, Form, InputNumber, message, Modal, Select, Tooltip} from "antd";
import {WasteStreamGet, WasteStreamPost, WasteStreamRemove, WasteStreamUpdate} from "../../../../models/waste_stream";
import {WasteStreamFilter} from "../../../../filters/WasteStreamCode";
import {ServiceUpdate} from "../../../../models/service";
import {EditQuantityWork} from "./EditQuantityWork";
import {EditQuantity} from "../hotsheet_performed/EditQuantity";

const Option = Select.Option;
const FormItem = Form.Item;
const _ = require('lodash');

class WorkOrderQuantityUpdateForm extends React.Component {
  state = {
    data: [],
    ws_id: 0,
    value: []
  };

  handleUpdateWasteStream = () => {
    message.success('Waste Stream Updated successfully');
    this.props.fetch();
    this.props.setModelVisible(false)
  };
  updateWasteStream = (index, manifest_index, id) => {
    const {data} = this.state;
    const waste_stream = data[manifest_index].waste_data[index];
    this.setState({ws_id: id});
    this.props.form.setFieldsValue({
      quantity: waste_stream.quantity,
      price: waste_stream.price,
      container_size: waste_stream.container_size,
      manifest: {key: data[manifest_index].id, label: data[manifest_index].manifest_number}
    });
    this.waste_stream_code.handleChange({
      key: waste_stream.waste_stream.id,
      label: waste_stream.waste_stream.code + ' - ' + waste_stream.waste_stream.description + ' - ' + waste_stream.waste_stream.unit
    });
  };

  SubmitWasteStream = () => {
    const {ws_id, data} = this.state;
    const {form} = this.props;
      form.validateFields((err, values) => {
        let ws_ids = data.map(service => service.waste_data.map(ws => ws.id));
        if (!err) {
          const manifest = values['manifest'].key;
          const index = _.findIndex(data, function(service) { return service.id.toString() === manifest; });
          WasteStreamPost(values)
            .then(response => {
              ws_ids = [response.id, ...ws_ids[index]];
              ServiceUpdate(manifest, {'waste_stream': ws_ids})
                .then(service_response => {
                  data.forEach((service, index) => {
                    if (service.id === Number(manifest)) {
                      data[index] = service_response
                    }
                  });
                  form.resetFields();
                  this.waste_stream_code.resetValue();
                  this.setState({data});
                })
            })
        }
      })
  };

  // removeWasteStream = (index, manifest_index, id) => {
  //   let data = this.state.data;
  //   if (id)
  //     WasteStreamRemove(id);
  //   data[manifest_index].waste_data.splice(index, 1);
  //   this.setState({data})
  // };

  componentDidUpdate(prevProps, prevState) {
    const {data} = this.state;
    const {row} = this.props;
    if (row.service.length !== data.length) {
      this.setState({data: row.service});
    }
  }
  updateData=(data)=>{
    this.setState(data)
  }

  render() {
    const {visible, row} = this.props;
    const {data, ws_id} = this.state;
    const {getFieldDecorator} = this.props.form;
    return (
      <Modal title="Edit Waste Stream" width={"82%"} centered visible={visible} onOk={this.handleUpdateWasteStream}
             onCancel={() => this.props.setModelVisible(false)} okText="Update Waste Stream" destroyOnClose={true}>
        <div className={"edit-qty-modal"}>
          <div className="row">
            <div className="col-sm-2 col-12">
              <FormItem label="Manifest">
                {getFieldDecorator('manifest', {
                  rules: [{required: true, message: 'Please select manifest'}],
                })(<Select style={{width: "100%"}} showSearch labelInValue placeholder="Select a manifest">
                  {data.map(service => (<Option key={service.id}>{service.manifest_number}</Option>))}
                </Select>)}
              </FormItem>
            </div>
            <div className="col-sm-4 col-12">
              <FormItem label="Waste Stream">
                {getFieldDecorator('waste_stream', {
                  rules: [{required: true, message: 'Please select waste stream code'}],
                })(<WasteStreamFilter onRef={ref => (this.waste_stream_code = ref)}/>)}
              </FormItem>
            </div>
            <div className="col-sm-2 col-12">
              <FormItem label="Quantity">
                <Tooltip title="Estimated gallons picked up">
                  {getFieldDecorator('quantity')(<InputNumber placeholder="Quantity"/>)}
                </Tooltip>
              </FormItem>
            </div>
            <div className="col-sm-2 col-12">
              <FormItem label="Price">
                {getFieldDecorator('price',)(<InputNumber placeholder="Price" min={0} step={0.1}/>)}
              </FormItem>
            </div>
            <div className="col-sm-2 col-12">
              <FormItem label="# of Containers">
                {getFieldDecorator('container_size')(<InputNumber placeholder="Containers"/>)}
              </FormItem>
            </div>
            <div className="col-12 ws-btn-div">
              <button type="button" onClick={this.SubmitWasteStream}
                      className="ant-btn ant-btn-primary m-t-5">{ws_id ? "Update Waste Stream" : "Add Waste Stream"}</button>
            </div>
          </div>
          <EditQuantityWork data={data} row={row} updateData={(data)=>this.updateData(data)} />
          {/*<div className="scroll-ws-part">*/}
          {/*  {data.map((service, index) => (*/}
          {/*    <div key={index} className="row">*/}
          {/*      <div className="col-12">*/}
          {/*        <h6>Manifest Number: </h6>*/}
          {/*        <p>{service.manifest_number}</p>*/}
          {/*      </div>*/}
          {/*      <div className="row padding-0 margin-0">*/}
          {/*        <div className="added-ws-div">*/}
          {/*          <p className="ws-data added-ws-h bg-trans">Added Waste Stream</p>*/}
          {/*          {service.waste_data.map((ws, sub_index) => <div key={sub_index} className="ws-content">*/}
          {/*              <p className="ws-data bg-trans">*/}
          {/*                <span className="ws-name">Waste Stream</span>*/}
          {/*                <span>Quantity</span>*/}
          {/*                <span>Price</span>*/}
          {/*                <span>Container #</span>*/}
          {/*                <span className="ws-edit">Edit</span>*/}
          {/*                <span className="ws-edit">Delete</span>*/}
          {/*              </p>*/}
          {/*              <p className="ws-data ws-tbody">*/}
          {/*                <span>{ws.waste_stream ? ws.waste_stream.code : ''} - {ws.waste_stream ? ws.waste_stream.unit : ''} - {ws.waste_stream.container ? ws.waste_stream.container.name : ''} </span>*/}
          {/*                <span>{ws.quantity ? ws.quantity : '-'}</span>*/}
          {/*                <span>{ws.price ? ws.price : '-'}</span>*/}
          {/*                <span>{ws.container_size ? ws.container_size : '-'}</span>*/}
          {/*                <span className="ws-edit">*/}
          {/*                    <Button className="action-ws-btn"*/}
          {/*                            onClick={() => this.updateWasteStream(sub_index, index, ws.id)} htmlType='button'><i*/}
          {/*                      className="fa fa-edit"/></Button>*/}
          {/*                  </span>*/}
          {/*                {sub_index ?*/}
          {/*                  <span className="ws-edit">*/}
          {/*                    <Button className="action-ws-btn"*/}
          {/*                            onClick={() => this.removeWasteStream(sub_index, index, ws.id)} htmlType='button'><i*/}
          {/*                      className="fa fa-trash"/></Button>*/}
          {/*                  </span> : ''}*/}
          {/*              </p>*/}
          {/*            </div>*/}
          {/*          )}*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  ))}*/}
          {/*</div>*/}
        </div>
      </Modal>
    )
  }
}

export const WorkOrderQuantityUpdate = Form.create()(WorkOrderQuantityUpdateForm);



// WEBPACK FOOTER //
// ./src/pages/tracks/work_perform/work_order/WorkOrderQuantityUpdate.jsx